var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0.0478516H0V17.1079H27V0.0478516Z",
    fill: "#FF9933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5.76294H0V11.4781H27V5.76294Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11.3928H0V17.1079H27V11.3928Z",
    fill: "#128807"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.8828C14.8421 10.8828 15.93 9.85129 15.93 8.57881C15.93 7.30633 14.8421 6.27478 13.5 6.27478C12.158 6.27478 11.07 7.30633 11.07 8.57881C11.07 9.85129 12.158 10.8828 13.5 10.8828Z",
    fill: "#000088"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5432C14.6432 10.5432 15.57 9.66402 15.57 8.57956C15.57 7.4951 14.6432 6.61597 13.5 6.61597C12.3568 6.61597 11.43 7.4951 11.43 8.57956C11.43 9.66402 12.3568 10.5432 13.5 10.5432Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.0051C13.7485 9.0051 13.95 8.81399 13.95 8.57824C13.95 8.34248 13.7485 8.15137 13.5 8.15137C13.2515 8.15137 13.05 8.34248 13.05 8.57824C13.05 8.81399 13.2515 9.0051 13.5 9.0051Z",
    fill: "#000088"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 8.74841C15.66 8.74841 15.66 8.83379 15.66 8.83379C15.66 8.91916 15.57 8.91916 15.57 8.91916C15.48 8.91916 15.48 8.83379 15.48 8.83379C15.48 8.74841 15.57 8.74841 15.57 8.74841Z",
    fill: "#000088"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5412L13.59 9.34598L13.5 8.83374L13.41 9.43135L13.5 10.5412Z",
    fill: "#000088"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.48 9.26025C15.57 9.26025 15.57 9.34563 15.57 9.431C15.57 9.51638 15.48 9.51638 15.39 9.51638C15.3 9.51638 15.3 9.431 15.3 9.34563C15.39 9.26025 15.39 9.26025 15.48 9.26025Z",
    fill: "#000088"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 10.5412L13.32 9.43135L13.41 8.83374L13.23 9.34598L12.96 10.5412Z",
    fill: "#000088"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.21 9.68677C15.3 9.68677 15.3 9.77214 15.21 9.85751C15.21 9.94289 15.12 9.94289 15.03 9.85751C14.94 9.85751 14.94 9.77214 15.03 9.68677C15.12 9.68677 15.21 9.68677 15.21 9.68677Z",
    fill: "#000088"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.42 10.2851L13.14 9.26065L13.41 8.74841L13.05 9.17528L12.42 10.2851Z",
    fill: "#000088"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.85 10.1133C14.85 10.1987 14.85 10.1987 14.85 10.2841C14.76 10.2841 14.76 10.2841 14.67 10.2841C14.67 10.1987 14.67 10.1987 14.67 10.1133C14.76 10.028 14.85 10.028 14.85 10.1133Z",
    fill: "#000088"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.06 9.94364L12.96 9.17528L13.32 8.74841L12.87 9.08991L12.06 9.94364Z",
    fill: "#000088"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 10.3693C14.4 10.4547 14.4 10.4547 14.31 10.5401C14.22 10.5401 14.22 10.5401 14.13 10.4547C14.13 10.3693 14.13 10.3693 14.22 10.2839C14.31 10.2839 14.4 10.3693 14.4 10.3693Z",
    fill: "#000088"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 9.60215L12.87 9.08991L13.32 8.74841L12.78 9.00453L11.7 9.60215Z",
    fill: "#000088"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.86 10.5398C13.86 10.6252 13.86 10.6252 13.77 10.6252C13.68 10.6252 13.68 10.6252 13.68 10.5398C13.68 10.4545 13.68 10.4545 13.77 10.4545C13.86 10.4545 13.86 10.4545 13.86 10.5398Z",
    fill: "#000088"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 9.09007L12.69 8.83395L13.23 8.66321L12.6 8.74858L11.43 9.09007Z",
    fill: "#000088"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.32 10.5398C13.32 10.6252 13.23 10.6252 13.23 10.6252C13.14 10.6252 13.14 10.5398 13.14 10.5398C13.14 10.4545 13.23 10.4545 13.23 10.4545C13.32 10.4545 13.32 10.5398 13.32 10.5398Z",
    fill: "#000088"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 8.57793L12.69 8.6633L13.32 8.57793L12.69 8.49255L11.43 8.57793Z",
    fill: "#000088"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.78 10.4547C12.78 10.5401 12.69 10.5401 12.6 10.5401C12.51 10.5401 12.6 10.4547 12.6 10.3693C12.6 10.2839 12.69 10.2839 12.78 10.2839C12.78 10.3693 12.78 10.3693 12.78 10.4547Z",
    fill: "#000088"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 8.06604L12.6 8.40754L13.23 8.49291L12.69 8.32216L11.43 8.06604Z",
    fill: "#000088"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.33 10.1988C12.33 10.2841 12.24 10.2841 12.15 10.1988C12.06 10.1988 12.06 10.1134 12.15 10.028C12.15 9.94265 12.24 9.94265 12.33 10.028C12.33 10.1134 12.33 10.1988 12.33 10.1988Z",
    fill: "#000088"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7 7.55432L12.78 8.23731L13.32 8.49343L12.87 8.15194L11.7 7.55432Z",
    fill: "#000088"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.88 9.85752C11.79 9.85752 11.79 9.85752 11.7 9.85752C11.7 9.77214 11.7 9.77214 11.7 9.68677C11.79 9.68677 11.79 9.68677 11.88 9.68677C11.97 9.77214 11.97 9.85752 11.88 9.85752Z",
    fill: "#000088"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.06 7.21313L12.87 8.06687L13.32 8.40836L12.96 7.9815L12.06 7.21313Z",
    fill: "#000088"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.61 9.43105C11.52 9.43105 11.52 9.43105 11.43 9.34567C11.34 9.2603 11.43 9.2603 11.52 9.17493C11.61 9.17493 11.61 9.17493 11.7 9.2603C11.7 9.34567 11.61 9.43105 11.61 9.43105Z",
    fill: "#000088"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.42 6.87183L12.96 7.98168L13.32 8.40855L13.05 7.89631L12.42 6.87183Z",
    fill: "#000088"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 8.91916C11.34 8.91916 11.34 8.91916 11.34 8.83379C11.34 8.74841 11.34 8.74841 11.43 8.74841C11.52 8.74841 11.52 8.74841 11.52 8.83379C11.52 8.91916 11.52 8.91916 11.43 8.91916Z",
    fill: "#000088"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 6.61597L13.23 7.8112L13.41 8.32344L13.32 7.72582L12.96 6.61597Z",
    fill: "#000088"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 8.40744C11.34 8.40744 11.34 8.32207 11.34 8.32207C11.34 8.23669 11.43 8.23669 11.43 8.23669C11.52 8.23669 11.52 8.32207 11.52 8.32207C11.52 8.40744 11.43 8.40744 11.43 8.40744Z",
    fill: "#000088"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.61597L13.41 7.8112L13.5 8.32344L13.59 7.72582L13.5 6.61597Z",
    fill: "#000088"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.52 7.8956C11.43 7.8956 11.43 7.81023 11.43 7.72485C11.52 7.72485 11.52 7.72485 11.61 7.72485C11.61 7.72485 11.7 7.81023 11.7 7.8956C11.61 7.8956 11.61 7.8956 11.52 7.8956Z",
    fill: "#000088"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.04 6.61597L13.68 7.72582L13.59 8.32344L13.77 7.8112L14.04 6.61597Z",
    fill: "#000088"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.79 7.46915C11.7 7.46915 11.7 7.38378 11.79 7.29841C11.79 7.21303 11.88 7.21303 11.97 7.29841C12.06 7.29841 12.06 7.38378 11.97 7.46915C11.88 7.46915 11.79 7.46915 11.79 7.46915Z",
    fill: "#000088"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 6.87183L13.86 7.89631L13.59 8.40855L13.95 7.98168L14.58 6.87183Z",
    fill: "#000088"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 7.04257C12.15 6.9572 12.15 6.9572 12.15 6.87183C12.24 6.87183 12.24 6.87183 12.33 6.87183C12.33 6.9572 12.33 6.9572 12.33 7.04257C12.24 7.12795 12.15 7.12795 12.15 7.04257Z",
    fill: "#000088"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.94 7.21313L14.04 7.9815L13.68 8.40836L14.13 8.06687L14.94 7.21313Z",
    fill: "#000088"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 6.78671C12.6 6.70134 12.6 6.70134 12.69 6.61597C12.78 6.61597 12.78 6.61597 12.87 6.70134C12.87 6.78671 12.87 6.78671 12.78 6.87209C12.69 6.87209 12.6 6.78671 12.6 6.78671Z",
    fill: "#000088"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 7.55432L14.13 8.06656L13.68 8.40806L14.22 8.15194L15.3 7.55432Z",
    fill: "#000088"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.14 6.61601C13.14 6.53064 13.14 6.53064 13.23 6.53064C13.32 6.53064 13.32 6.53064 13.32 6.61601C13.32 6.70139 13.32 6.70139 13.23 6.70139C13.14 6.70139 13.14 6.70139 13.14 6.61601Z",
    fill: "#000088"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 8.06604L14.31 8.32216L13.77 8.49291L14.4 8.40754L15.57 8.06604Z",
    fill: "#000088"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.68 6.61601C13.68 6.53064 13.77 6.53064 13.77 6.53064C13.86 6.53064 13.86 6.61601 13.86 6.61601C13.86 6.70139 13.77 6.70139 13.77 6.70139C13.68 6.70139 13.68 6.61601 13.68 6.61601Z",
    fill: "#000088"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 8.57793L14.31 8.49255L13.77 8.57793L14.4 8.6633L15.57 8.57793Z",
    fill: "#000088"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.22 6.70134C14.22 6.61597 14.31 6.61597 14.4 6.61597C14.4 6.70134 14.4 6.70134 14.4 6.78671C14.4 6.78671 14.31 6.87209 14.22 6.87209C14.22 6.78671 14.22 6.78671 14.22 6.70134Z",
    fill: "#000088"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 9.09007L14.4 8.74858L13.77 8.66321L14.31 8.83395L15.57 9.09007Z",
    fill: "#000088"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.67 6.95722C14.67 6.87184 14.76 6.87184 14.85 6.95722C14.94 6.95722 14.94 7.04259 14.85 7.12797C14.85 7.21334 14.76 7.21334 14.67 7.12797C14.67 7.04259 14.67 6.95722 14.67 6.95722Z",
    fill: "#000088"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 9.60232L14.22 8.91933L13.68 8.66321L14.13 9.0047L15.3 9.60232Z",
    fill: "#000088"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.12 7.29834C15.21 7.29834 15.21 7.29834 15.3 7.29834C15.3 7.38371 15.3 7.38371 15.3 7.46909C15.21 7.46909 15.21 7.46909 15.12 7.46909C15.03 7.38371 15.03 7.29834 15.12 7.29834Z",
    fill: "#000088"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.94 9.94364L14.13 9.08991L13.68 8.74841L14.04 9.17528L14.94 9.94364Z",
    fill: "#000088"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15.39 7.72485C15.48 7.72485 15.48 7.72485 15.57 7.81023C15.57 7.8956 15.57 7.8956 15.48 7.98097C15.39 7.98097 15.39 7.98097 15.3 7.8956C15.3 7.81023 15.39 7.72485 15.39 7.72485Z",
    fill: "#000088"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 10.2851L14.04 9.17528L13.68 8.74841L13.95 9.26065L14.58 10.2851Z",
    fill: "#000088"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M15.57 8.23669C15.66 8.23669 15.66 8.23669 15.66 8.32207C15.66 8.40744 15.66 8.40744 15.57 8.40744C15.48 8.40744 15.48 8.40744 15.48 8.32207C15.48 8.23669 15.48 8.23669 15.57 8.23669Z",
    fill: "#000088"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14.04 10.5412L13.77 9.34598L13.59 8.83374L13.68 9.43135L14.04 10.5412Z",
    fill: "#000088"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.cc8afea2731916453e47e18d1f475475.svg";
export { ForwardRef as ReactComponent };